var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    x: 0,
    y: 0,
    viewBox: "-293 384 25 23",
    xmlSpace: "preserve",
    width: 25,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st0{fill:#000}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g14",
    transform: "matrix(1.26249 0 0 1.36017 73.614 -144.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-277.4 396h-2c-.4 0-.5-.1-.5-.5v-3c0-.3.2-.5.5-.5 1.3-.1 2.6-.3 3.9-.4.4 0 .7.1.7.6v3.3c0 .4-.2.6-.6.6-.7-.1-1.4-.1-2-.1z",
    id: "path4",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-274.9 399.3v1.7c0 .4-.1.6-.6.6-1.4-.1-2.8-.3-4.1-.4-.3 0-.4-.3-.4-.5v-3c0-.4.2-.5.6-.5h3.9c.5 0 .6.2.6.6v1.5z",
    id: "path6",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-283.5 396h-1.9c-.4 0-.6-.1-.6-.6v-2.3c0-.4.2-.6.6-.7 1.3-.1 2.7-.3 4-.4.4 0 .5.1.5.5v2.9c0 .4-.2.5-.5.5-.8.1-1.5.1-2.1.1z",
    id: "path8",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-283.5 397h1.9c.4 0 .6.1.6.5v2.9c0 .4-.2.5-.5.5-1.3-.1-2.7-.3-4-.4-.4 0-.6-.2-.6-.7v-2.2c0-.5.2-.7.7-.7.6.1 1.2.1 1.9.1z",
    id: "path10",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.4bad6b703c040b3c6c56d87d47abfcfb.svg";
export { ForwardRef as ReactComponent };